import { render, staticRenderFns } from "./messageContainer.vue?vue&type=template&id=73476f74"
import script from "./messageContainer.vue?vue&type=script&lang=ts"
export * from "./messageContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports